import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ThemeContext } from "../../ThemedContext/Provider";
import Button from '../../components/Commons/button';
import {
  Container,
  FormContainer,
  Form,
  FormDiv,
  Input,
  ImageWrapper,
  LoginOptions,
  Wrapper
} from "./FormStyle";
import { Icon } from "semantic-ui-react";
import { loginUser } from "../../redux/user-redux/userStore";
import { NavLink } from 'react-bootstrap'

const Login = () => {
  const { theme } = useContext(ThemeContext);

  const [body, setBody] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: null,
    password: null,
  });

  const dispatch = useDispatch();
  const history = useHistory();

  const error = useSelector(({ useReducer: { login_errors } }) => login_errors);

  useEffect(() => {
    setErrors({
      email: error !== null && error.email,
      password: error !== null && error.password,
    });
  }, [error]);

  const handleInput = ({ target: { name, value } }) => {
    setBody({
      ...body,
      [name]: value,
    });
  };

  const onsubmit = (e) => {
    e.preventDefault();
    loginUser(dispatch, body, history);
  };

  const welcome = "../../../assets/images/headphone_login.png";

  return (
    <Wrapper themed={theme}>
      <FormContainer themed={theme}>
        <Container>
          <ImageWrapper style={{ width: '7em' }}>
            <img src={welcome} alt='welcome' />
          </ImageWrapper>
          <h2>Welcome</h2>
          <p>Login to continue</p>
          <p style={{ textAlign: 'center' }}>
            If your yet to signup for some awesome package hit the register button
            below
          </p>
          <NavLink className='link' href='/register'>
            Register
          </NavLink>
        </Container>
        <Form onSubmit={onsubmit}>
          {errors && (
            <p style={{ textAlign: "center", color: "red" }}>
              {error === "No Network" && "Check your network"}
            </p>
          )}
          {errors && (
            <p style={{ textAlign: "center", color: "red" }}>
              {error === "Email or password incorrect" && error}
            </p>
          )}
          <LoginOptions>
            <Button color='facebook'>
              <Icon name='facebook' /> Facebook
            </Button>
            <Button color='twitter'>
              <Icon name='twitter' /> Twitter
            </Button>
            <Button color='instagram'>
              <Icon name='instagram' /> Instagram
            </Button>
          </LoginOptions>
          <p style={{ textAlign: 'center' }}>OR</p>
          <FormDiv>
            <Input
              type='email'
              placeholder='Email Address'
              name='email'
              onChange={handleInput}
            />
            {errors.email && errors.email[0] === "Email must be valid" && (
              <p style={{ paddingTop: "0.5em", color: "red" }}>
                {errors.email}
              </p>
            )}
          </FormDiv>
          <FormDiv>
            <Input
              type='password'
              placeholder='Password'
              name='password'
              onChange={handleInput}
            />
            {(errors.password &&
              errors.password[0] === "Password must not be empty" && (
                <p style={{ paddingTop: "0.5em", color: "red" }}>
                  {errors.password[0]}
                </p>
              )) ||
              (errors.password &&
                errors.password[0] ===
                "Password must be atlease six characters" && (
                  <p style={{ paddingTop: "0.5em", color: "red" }}>
                    {errors.password[0]}
                  </p>
                ))}
          </FormDiv>
          <Button themed={theme} style={{ marginTop: '2em' }}><Icon name="mail outline" />Login</Button>
        </Form>
      </FormContainer>
    </Wrapper>
  );
};

export default Login;
